import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import ServiceListContainer from "../containers/service/service-list";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const ServicePage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="adbaja – Service" />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="Nos Services"
                        excerpt="Développement informatique, Sécurité informatiques,  <br />
                        service informatiques, service bureautiques"
                        image="./images/service/2.png"
                    />
                    <ServiceListContainer />
                    <NewsletterArea />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default ServicePage;
